import {
    CREATE_FABRIC_PO_MASTER_REQUEST_DK,
    CREATE_FABRIC_PO_MASTER_SUCCESS_DK,
    CREATE_FABRIC_PO_MASTER_FAILURE_DK,
    DELETE_FABRIC_PO_MASTER_REQUEST_DK,
    DELETE_FABRIC_PO_MASTER_SUCCESS_DK,
    DELETE_FABRIC_PO_MASTER_FAILURE_DK,
    FETCH_SINGLE_FABRIC_PO_MASTER_REQUEST_DK,
    FETCH_SINGLE_FABRIC_PO_MASTER_SUCCESS_DK,
    FETCH_SINGLE_FABRIC_PO_MASTER_FAILURE_DK,
    FETCH_FABRIC_PO_MASTER_REQUEST_DK,
    FETCH_FABRIC_PO_MASTER_SUCCESS_DK,
    FETCH_FABRIC_PO_MASTER_FAILURE_DK,
    UPDATE_FABRIC_PO_MASTER_REQUEST_DK,
    UPDATE_FABRIC_PO_MASTER_SUCCESS_DK,
    UPDATE_FABRIC_PO_MASTER_FAILURE_DK,
    RESET_FABRIC_PO_MASTER_INFO_DK,
    CREATE_FABRIC_PO_MASTER_FORM_DK,
    UPDATE_FABRIC_PO_MASTER_FORM_DK,
    NAVIGATE_FABRIC_PO_DETAILS_DK,
    NAVIGATE_FABRIC_PO_MASTER_DK,
    FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_SUCCESS_DK,
    FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_FAILURE_DK,
    FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_REQUEST_DK,
    FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_FABRIC_PO_INVOICE_REQUEST_DK,
    FETCH_FABRIC_PO_INVOICE_SUCCESS_DK,
    FETCH_FABRIC_PO_INVOICE_FAILURE_DK,
    RESET_FABRIC_PO_INVOICE_DK
} from './fabricPoMaster.actionsType';

export const FABRIC_PO_MASTER_DK = 'fabricPoMasterDK';

let initialState = {
    loading: false,
    fabricPoMaster: [],
    fabricPoMasterForm: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    selectedState: {},
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    generalItemList: [],
    generalHeaderList: [],
    fabricPoInvoice: [],
    uomList: [],
    errorMessage: '',
    singleFabricPoData: {},
    isFabricPoDetails: false,
    detailsId: '',
    activeKey: 1
};

export let fabricPoMasterDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_FABRIC_PO_MASTER_REQUEST_DK:
        case FETCH_FABRIC_PO_INVOICE_REQUEST_DK:
        case CREATE_FABRIC_PO_MASTER_REQUEST_DK:
        case UPDATE_FABRIC_PO_MASTER_REQUEST_DK:
        case FETCH_SINGLE_FABRIC_PO_MASTER_REQUEST_DK:
        case DELETE_FABRIC_PO_MASTER_REQUEST_DK:
        case FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_FABRIC_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoMaster: updatePayload
            };
        case FETCH_FABRIC_PO_INVOICE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoInvoice: updatePayload
            };
        case FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_SUCCESS_DK:
            if (payload == 52) {
                return {
                    ...state,
                    loading: false,
                    typeOfPoList: updatePayload
                };
            } else if (payload == 46) {
                return {
                    ...state,
                    loading: false,
                    sourceList: updatePayload
                };
            } else if (payload == 28) {
                return {
                    ...state,
                    loading: false,
                    departmentList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    deliveryAt: updatePayload
                };
            } else if (payload == 22) {
                return {
                    ...state,
                    loading: false,
                    uomList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    generalHeaderList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    generalItemList: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case CREATE_FABRIC_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case UPDATE_FABRIC_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case FETCH_SINGLE_FABRIC_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoMasterForm: updatePayload
            };
        case DELETE_FABRIC_PO_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case RESET_FABRIC_PO_MASTER_INFO_DK:
            return {
                ...state,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                activeKey: 1
            };
        case CREATE_FABRIC_PO_MASTER_FORM_DK:
        case UPDATE_FABRIC_PO_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                fabricPoMasterForm: {
                    ...state.fabricPoMasterForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_FABRIC_PO_MASTER_FAILURE_DK:
        case FETCH_FABRIC_PO_INVOICE_FAILURE_DK:
        case CREATE_FABRIC_PO_MASTER_FAILURE_DK:
        case UPDATE_FABRIC_PO_MASTER_FAILURE_DK:
        case FETCH_SINGLE_FABRIC_PO_MASTER_FAILURE_DK:
        case DELETE_FABRIC_PO_MASTER_FAILURE_DK:
        case FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_FABRIC_PO_DETAILS_DK:
            return {
                ...state,
                isFabricPoDetails: true,
                singleFabricPoData: updatePayload.singleFabricPoData
            };
        case NAVIGATE_FABRIC_PO_MASTER_DK:
            return {
                ...state,
                isFabricPoDetails: false
            };
        case RESET_FABRIC_PO_INVOICE_DK:
            return {
                ...state,
                fabricPoInvoice: []
            };
        case FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
